import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConfigProvider } from 'antd'
import { analytics } from './services/index'
import './utils'
import { store, history } from './redux/index'
import Router from './router'
import * as serviceWorker from './serviceWorker'
// app styles
import './global.scss'

/** Initilize ReactGA  */
analytics.initialize()

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider>
      <Router history={history} />
    </ConfigProvider>
  </Provider>,
  document.getElementById('root'),
)

// serviceWorker.register()
serviceWorker.unregister()
